var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Form',{attrs:{"fnoname":'910.00',"fnoperiod":'halfyear',"fnotitle":'Упрощенная декларация для субъектов малого бизнеса'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }